var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3"},[_c('h2',[_vm._v("Dependents")]),_c('pre',[_vm._v(_vm._s(_vm.content_name.itemRevision.header.metadata.title))]),_c('pre',[_vm._v("Show dependents of current content")])])
}
var staticRenderFns = []

export { render, staticRenderFns }